exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".width-35[data-v-48fdeeaa] {\n  display: inline-block;\n  width: 34.5%;\n}\n.width-50[data-v-48fdeeaa] {\n  display: inline-block;\n  width: 49.5%;\n}\n.width-65[data-v-48fdeeaa] {\n  display: inline-block;\n  width: 64.5%;\n}", ""]);

// exports
